import React, { memo } from "react";
import { Link } from "react-router-dom";
import { philosopher } from "@/lib/fonts";
import CustomImage from "@/app/components/common/Image";
import { routes } from "@/lib/constants";
import { ISubSubCategory } from "muminsmart-utils";

interface CategoryTileProps {
  category: ISubSubCategory;
}

function CategoryTile({ category }: CategoryTileProps) {
  return (
    <Link
      to={routes.categories.subCategories.subSubCategories.id(
        category.categoryId,
        category.subCategoryId,
        category.id,
      )}
      className="flex w-20 flex-col items-center"
    >
      <div className="flex w-full flex-col items-center rounded-xl bg-linear-to-t from-20% from-[#F0E0C7] to-70% to-transparent">
        <div className="flex flex-col items-center justify-center text-center text-xs text-gray-800">
          <CustomImage
            src={category.image}
            alt={category.name}
            className="h-full w-full rounded-xl object-contain"
          />
        </div>
      </div>
      <span
        className={`mt-1 line-clamp-1 text-wrap text-center text-md text-[#6F6F6F] ${philosopher.className}`}
      >
        {category.name}
      </span>
    </Link>
  );
}

export default memo(CategoryTile);
